import React, { useMemo} from "react";
let options = [
  {
    name: "b2b",
  },
  {
    name: "healthtech",
  },
  {
    name: "saas",
  },
];

const Dropdown = ({selected,setSelected}) => {
  const onChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelected([...selected, { name: value }]);
    } else {
      setSelected(selected.filter((item) => item.name !== value));
    }
  };
  const getComputedNames = useMemo(
    () =>
      selected
        .map((item) => item.name)
        .sort()
        .join(", "),
    [selected]
  );
  return (
    <div className="dropdown">
      <button className="dropdown-button">
        {" "}
        <span>
          {selected.length ? getComputedNames : "All Industries"}
        </span>{" "}
        <img src={require("../../assets/images/arrow-down.svg")} alt="arrow" />
      </button>
      <div className="options">
        {options.map((item,index) => {
          return (
            <div className="checkbox-box" key={index}>
              <input
                type={"checkbox"}
                name="options"
                id="flexCheckDefault"
                value={item.name}
                onClick={onChange}
              />
              <label htmlFor="flexCheckDefault" className="checkbox-label">
                {item.name}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Dropdown;
